/** Build My todos title + link from a desk doc — plan/50 C remind-from-doc. */

export type RemindFromDocKind =
  | "sales_order"
  | "purchase_order"
  | "sales_invoice"
  | "purchase_invoice"
  | "customer_payment"
  | "supplier_payment"
  | "sales_delivery"
  | "goods_receipt"
  | "sales_shipment"
  | "purchase_shipment"
  | "pos_ticket"
  | "sales_return"
  | "stock_conversion"
  | "journal_entry";

export function remindFromDocTitle(input: {
  docNumber: string;
  partyName?: string | null;
}): string {
  const number = input.docNumber.trim() || "Document";
  const party = (input.partyName ?? "").trim();
  const title = party ? `${number} · ${party}` : number;
  return title.length > 200 ? title.slice(0, 200) : title;
}

export function remindFromDocLinkPath(input: {
  companySlug: string;
  kind: RemindFromDocKind;
  docId: string;
}): string {
  const slug = input.companySlug.trim();
  const id = input.docId.trim();
  switch (input.kind) {
    case "purchase_order":
      return `/c/${slug}/purchasing/orders/${id}`;
    case "sales_invoice":
      return `/c/${slug}/sales/invoices/${id}`;
    case "purchase_invoice":
      return `/c/${slug}/purchasing/invoices/${id}`;
    case "customer_payment":
      return `/c/${slug}/sales/payments/${id}`;
    case "supplier_payment":
      return `/c/${slug}/purchasing/payments/${id}`;
    case "sales_delivery":
      return `/c/${slug}/sales/deliveries/${id}`;
    case "goods_receipt":
      return `/c/${slug}/purchasing/receipts/${id}`;
    case "sales_shipment":
      return `/c/${slug}/sales/in-transit/${id}`;
    case "purchase_shipment":
      return `/c/${slug}/purchasing/in-transit/${id}`;
    case "pos_ticket":
      return `/c/${slug}/pos/tickets/${id}`;
    case "sales_return":
      return `/c/${slug}/returns/${id}`;
    case "stock_conversion":
      return `/c/${slug}/inventory/conversions/${id}`;
    case "journal_entry":
      return `/c/${slug}/gl/journals/${id}`;
    case "sales_order":
    default:
      return `/c/${slug}/sales/orders/${id}`;
  }
}
